/**
 * 响应式断点 —— 单一来源（TS 侧）
 *
 * ⚠️ 必须与 src/assets/style/breakpoints.scss 中的值保持一致。
 * JS 通过 matchMedia 读取、SCSS 通过 @media 读取，二者无法共享同一字面量，
 * 因此在这两处集中定义、改动时同步修改。
 *
 * - mobile：手机（用于 isMobile 组件切换 / 逻辑分支）
 * - tablet：平板及以下（用于桌面/移动布局与设计稿基准切换）
 */
export const BREAKPOINTS = {
  mobile: 768,
  tablet: 1200,
} as const;
